module.exports = __webpack_public_path__ + "img/ic_profile_wizard_notification_preference.93b843d2.svg";